import { useState } from 'react';

import { createController } from '../utils/controller';

export function useController(provided) {
  const [controller] = useState(provided || createController);
  return controller;
}
